import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'PowerUsageMonthCache';

/**
 * Holds power usage per month keyed by rk (1 rk = 1 month).
 */
class PowerUsageMonthCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Months sorted by start, oldest first.
     * @returns {object[]}
     */
    getAll = () => {
        try {
            return [...this._items].sort((a, b) => a.start - b.start);
        } catch (error) {
            this.logError('getAll', error.message);
            return [];
        }
    };
}

const powerUsageMonthCache = new PowerUsageMonthCache();
export default powerUsageMonthCache;
